import { useHowItWorksContent } from '../../../context/ContentContext';
import './HowItWorks.css';

// Step Icons
import oneIcon from '../../../assets/images/one.svg';
import twoIcon from '../../../assets/images/two.svg';
import threeIcon from '../../../assets/images/three.svg';
import fourIcon from '../../../assets/images/four.svg';
import ContainerIcon from '../../../assets/images/Container.svg';

const iconMap = {
    'one.svg': oneIcon,
    'two.svg': twoIcon,
    'three.svg': threeIcon,
    'four.svg': fourIcon
};

export default function HowItWorks() {
    const { eyebrow, title, steps } = useHowItWorksContent();

    return (
        <section className="how-it-works" id='how-it-works'>
            <div className="how-it-works__inner max-width">
                <div className="how-it-works__layout">
                    <div className="how-it-works__header">
                        <p className="how-it-works__eyebrow">{eyebrow}</p>
                        <div className="how-it-works__title">
                            {title.main}
                            <span className="how-it-works__title-highlight">{title.highlight}</span>
                        </div>
                    </div>

                    <div className="how-it-works__list" style={{ '--connector-img': `url(${ContainerIcon})` }}>
                        {steps.map((step, index) => (
                            <div key={index} className="how-it-works__step">
                                <div className="how-it-works__step-icon-wrap">
                                    <img src={iconMap[step.icon]} alt="" className="how-it-works__step-icon" />
                                </div>
                                <div className="how-it-works__step-content">
                                    <div className="how-it-works__step-title">{step.title}</div>
                                    <p className="how-it-works__step-description">{step.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
